import * as yup from "yup";

export const authSchema = yup.object({
  email: yup.string().email().required("Email is required"),
  password: yup.string().required("Password is required"),
});

export type AuthSchema = yup.InferType<typeof authSchema>;
